import { defineMessages } from 'react-intl';

/** The copy of the song files in the catalog (designs release-kit f1, f2, f3, g1, g2, k1). */
export const catalogSongMessages = defineMessages({
  column: { id: 'app.sml.catalog.song.column', defaultMessage: 'Song' },
  cellMasterLyrics: { id: 'app.sml.catalog.song.cell.masterLyrics', defaultMessage: 'Master + lyrics' },
  cellMaster: { id: 'app.sml.catalog.song.cell.master', defaultMessage: 'Master' },
  cellNoLyrics: { id: 'app.sml.catalog.song.cell.noLyrics', defaultMessage: 'No lyrics' },
  cellProcessing: { id: 'app.sml.catalog.song.cell.processing', defaultMessage: 'Reading the song' },
  cellFailed: { id: 'app.sml.catalog.song.cell.failed', defaultMessage: 'Upload it again' },
  cellAdd: { id: 'app.sml.catalog.song.cell.add', defaultMessage: '+ Add the master' },
  cellOpen: { id: 'app.sml.catalog.song.cell.open', defaultMessage: 'Song files of {title}' },
  bpm: { id: 'app.sml.catalog.song.bpm', defaultMessage: '{bpm} BPM' },
  sizeMb: { id: 'app.sml.catalog.song.sizeMb', defaultMessage: '{size} MB' },
  hookAt: { id: 'app.sml.catalog.song.hookAt', defaultMessage: 'Hook {time}' },
  menuSongFiles: { id: 'app.sml.catalog.song.menu', defaultMessage: 'Song files' },
  menuSongFilesHint: { id: 'app.sml.catalog.song.menuHint', defaultMessage: 'Master, lyrics' },
  sheetOut: { id: 'app.sml.catalog.song.sheet.out', defaultMessage: 'out {date}' },
  master: { id: 'app.sml.catalog.song.master', defaultMessage: 'Master' },
  replace: { id: 'app.sml.catalog.song.replace', defaultMessage: 'Replace' },
  replaceWarning: {
    id: 'app.sml.catalog.song.replaceWarning',
    defaultMessage: 'New renders use the new master. Finished videos keep the old one.',
  },
  replaceConfirm: { id: 'app.sml.catalog.song.replaceConfirm', defaultMessage: 'Pick the new master' },
  masterProcessing: {
    id: 'app.sml.catalog.song.masterProcessing',
    defaultMessage: 'MUSIC24 reads the song. This takes about 1 minute.',
  },
  masterFailed: {
    id: 'app.sml.catalog.song.masterFailed',
    defaultMessage: 'MUSIC24 cannot read this master. Upload it again.',
  },
  lyrics: { id: 'app.sml.catalog.song.lyrics', defaultMessage: 'Lyrics' },
  lyricsPlaceholder: {
    id: 'app.sml.catalog.song.lyricsPlaceholder',
    defaultMessage: 'Paste the lyrics, one line per lyric line',
  },
  lyricsSave: { id: 'app.sml.catalog.song.lyricsSave', defaultMessage: 'Save the lyrics' },
  optional: { id: 'app.sml.catalog.song.optional', defaultMessage: 'optional' },
  isrc: { id: 'app.sml.catalog.song.isrc', defaultMessage: 'ISRC' },
  isrcHelp: {
    id: 'app.sml.catalog.song.isrcHelpSong',
    defaultMessage:
      'Your distributor gives it before the release. With it, MUSIC24 links the release to this song on day one.',
  },
  isrcError: {
    id: 'app.sml.catalog.song.isrcError',
    defaultMessage: 'An ISRC has 12 characters: 2 letters, 3 letters or numbers, 7 numbers.',
  },
  isrcSave: { id: 'app.sml.catalog.song.isrcSave', defaultMessage: 'Save the ISRC' },
  onServices: { id: 'app.sml.catalog.song.onServices', defaultMessage: 'On services' },
  made: { id: 'app.sml.catalog.song.made', defaultMessage: 'Made from this song' },
  madeReels: {
    id: 'app.sml.catalog.song.madeReels',
    defaultMessage: '{count, plural, one {# AI reel} other {# AI reels}}',
  },
  madeKitAssets: {
    id: 'app.sml.catalog.song.madeKitAssets',
    defaultMessage: '{count, plural, one {# kit asset} other {# kit assets}}',
  },
  madeKitAssetsSource: { id: 'app.sml.catalog.song.madeKitAssetsSource', defaultMessage: 'Releases' },
  openSong: { id: 'app.sml.catalog.song.openSong', defaultMessage: 'Open {title}' },
  madePosts: { id: 'app.sml.catalog.song.madePosts', defaultMessage: '{count, plural, one {# post} other {# posts}}' },
  madePostsSource: { id: 'app.sml.catalog.song.madePostsSource', defaultMessage: 'Calendar' },
  madeNothing: { id: 'app.sml.catalog.song.madeNothing', defaultMessage: 'Nothing made from this song yet.' },
  open: { id: 'app.sml.catalog.song.open', defaultMessage: 'Open' },
  makeReel: { id: 'app.sml.catalog.song.makeReel', defaultMessage: 'Make a reel' },
  close: { id: 'app.sml.catalog.song.close', defaultMessage: 'Close' },
  dropTitle: { id: 'app.sml.catalog.song.dropTitle', defaultMessage: 'Drop the master here' },
  dropHint: {
    id: 'app.sml.catalog.song.dropHint',
    defaultMessage: 'wav, flac, aiff, mp3, m4a or aac, up to {max} MB',
  },
  addSong: { id: 'app.sml.catalog.song.addSong', defaultMessage: 'Add the song' },
  addSongHint: {
    id: 'app.sml.catalog.song.addSongHint',
    defaultMessage: 'wav, flac, aiff, mp3, m4a or aac, up to {max} MB. Every reel and video of this song uses it.',
  },
  pick: { id: 'app.sml.catalog.song.pick', defaultMessage: 'Pick a file' },
  picked: { id: 'app.sml.catalog.song.picked', defaultMessage: 'Waiting for your OK · {size} MB' },
  pickedReady: { id: 'app.sml.catalog.song.pickedReady', defaultMessage: '{size} MB · uploads when you save' },
  remove: { id: 'app.sml.catalog.song.remove', defaultMessage: 'Remove' },
  uploading: { id: 'app.sml.catalog.song.uploading', defaultMessage: 'Uploading · {percent}%' },
  tooBig: {
    id: 'app.sml.catalog.song.tooBig',
    defaultMessage: 'That file is over {max} MB. Export the song as an mp3 and try again.',
  },
  wrongType: {
    id: 'app.sml.catalog.song.wrongType',
    defaultMessage: 'MUSIC24 cannot read this file type. Use wav, flac, aiff, mp3, m4a or aac.',
  },
  uploadFailed: { id: 'app.sml.catalog.song.uploadFailed', defaultMessage: 'The upload failed. Try again.' },
  uploadBlocked: {
    id: 'app.sml.catalog.song.uploadBlocked',
    defaultMessage:
      'The file did not reach our storage. Check your connection, turn off ad blockers, VPNs or browser shields for music24.com, then try again.',
  },
  uploadRefused: {
    id: 'app.sml.catalog.song.uploadRefused',
    defaultMessage: 'Our storage refused the file (error {status}). Try again in a minute.',
  },
  fileUnreadable: {
    id: 'app.sml.catalog.song.fileUnreadable',
    defaultMessage:
      'Your browser cannot read this file now. It moved, changed or is not on this computer. Pick it again.',
  },
  rights: { id: 'app.sml.catalog.song.rights', defaultMessage: 'I own or control the rights to this recording.' },
  rightsNote: {
    id: 'app.sml.catalog.song.rightsNote',
    defaultMessage: 'MUSIC24 uses the file only to make videos and images for you. We ask once for this artist.',
  },
  rightsNeeded: {
    id: 'app.sml.catalog.song.rightsNeeded',
    defaultMessage: 'Tick the box first. Then upload the master.',
  },
  upload: { id: 'app.sml.catalog.song.upload', defaultMessage: 'Upload' },
  cancel: { id: 'app.sml.catalog.song.cancel', defaultMessage: 'Cancel' },
  stop: { id: 'app.sml.catalog.song.stop', defaultMessage: 'Stop' },
  finishing: { id: 'app.sml.catalog.song.finishing', defaultMessage: 'Saving the master' },
  stepClaimed: { id: 'app.sml.catalog.song.step.claimed', defaultMessage: '1 · Claimed ✓' },
  stepAdded: { id: 'app.sml.catalog.song.step.added', defaultMessage: '1 · Added ✓' },
  stepMaster: { id: 'app.sml.catalog.song.step.master', defaultMessage: '2 · The master' },
  stepTitle: { id: 'app.sml.catalog.song.step.title', defaultMessage: 'Add the master of {title}' },
  stepBody: {
    id: 'app.sml.catalog.song.step.body',
    defaultMessage: 'Upload it once. Every reel, video and kit asset of this song uses it.',
  },
  stepInCatalog: { id: 'app.sml.catalog.song.step.inCatalog', defaultMessage: 'In your catalog' },
  later: { id: 'app.sml.catalog.song.later', defaultMessage: 'I’ll do it later' },
  laterNote: {
    id: 'app.sml.catalog.song.laterNote',
    defaultMessage: 'You can add it later from the catalog or when you make a reel.',
  },
  save: { id: 'app.sml.catalog.song.save', defaultMessage: 'Save the master' },
});
